import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AssignSalespersonGQL } from '@wb/core/schema/mutation-definitions/admin.graphql';
import { RoutingService } from '@wb/core/services/routing.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-assign-salesperson',
  templateUrl: './assign-salesperson.component.html',
  styleUrls: ['./assign-salesperson.component.sass'],
})
export class AssignSalespersonDialogComponent implements OnInit, OnDestroy {
  salespersonEmail?: string;

  private destroyed$ = new Subject<void>();

  constructor(
    private dialogRef: MatDialogRef<AssignSalespersonDialogComponent>,
    private readonly assignSalespersonGQL: AssignSalespersonGQL,
    private readonly routing: RoutingService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    this.salespersonEmail = this.data.salesperson ?? '';
  }

  ngOnDestroy(): void {
    this.routing.assignLeadToUser = false;
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onSave(): void {
    if (this.data.leadUid && this.data.salespersonUid) {
      const leadUid = this.data.leadUid;
      const userUid = this.data.salespersonUid;

      this.assignSalespersonGQL
        .mutate({ userUid, leadUid })
        .pipe(takeUntil(this.destroyed$), (result) => result)
        .subscribe();
    }

    this.dialogRef.close();
  }
}
